import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';
import store from '@/store/index';
import '../types';
import { Characteristic, ValueDefinition } from '../types';

//KTU_MM_FALZ_O_GBS //KTU_MM_FALZ_GBS //KTU_MM_FALZ_O_SO_GBS
export const setTurOberflacheFALZGBSValue = () : any[] => {
    var KTU_MM_FALZ_O_GBSResult = '';
    var KTU_MM_FALZ_GBSResult = '';
    var KTU_MM_FALZ_O_SO_GBSResult = '';
    const model = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection); // KTU_MM_MODELL;
    const falzgeometrie = helper.GetDependencyValueCode('KTU_MM_FALZGEOMETRIE', contex.Functions);
    const falzOberflacheBS = helper.GetDependencyValueCode('KTU_MM_FALZ_O_BS', contex.DoorLeafSurface);
    const turOberflacheBS = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const turOberflacheGBS = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const falzBs = helper.GetDependencyValueCode('KTU_MM_FALZ_BS', contex.DoorLeafSurface);
    const falzOberflacheSonderBs = helper.GetDependencyValueCode('KTU_MM_FALZ_O_SO_BS', contex.DoorLeafSurface);
    const tuerOberflacheSonderGBs = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_SO_GBS', contex.DoorLeafSurface);
    if(model == "CERT" && falzgeometrie == "F"){
        KTU_MM_FALZ_O_GBSResult = falzOberflacheBS;
        KTU_MM_FALZ_GBSResult = falzBs;
        KTU_MM_FALZ_O_SO_GBSResult = falzOberflacheSonderBs;
    }else {
        if(turOberflacheBS == "DEKOR" && turOberflacheGBS == "DEKOR"){
            var KTU_MM_TUEROBERFL_BS = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_BS', contex.DoorLeafSurface);
            var KTU_MM_TUEROBERFL_GBS = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_GBS', contex.DoorLeafSurface);
            if(KTU_MM_TUEROBERFL_BS == KTU_MM_TUEROBERFL_GBS){
                KTU_MM_FALZ_O_GBSResult = falzOberflacheBS;
                KTU_MM_FALZ_GBSResult = falzBs;
                KTU_MM_FALZ_O_SO_GBSResult = falzOberflacheSonderBs;
            }else {
                if(falzBs == "KEINE LACKIERUNG")
                {
                    KTU_MM_FALZ_GBSResult = falzBs;
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "KLARLACK")
                {
                    KTU_MM_FALZ_GBSResult = falzBs;
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "LACKIERUNG1")
                {
                    KTU_MM_FALZ_GBSResult = "BEIZE1";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "BEIZE1"){
                    KTU_MM_FALZ_GBSResult = "BEIZE2";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else {
                    KTU_MM_FALZ_GBSResult = "BEIZE2";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }
            }
        }
        
        else if(turOberflacheBS == "FURNIER" && turOberflacheGBS == "FURNIER"){
            var KTU_MM_TUEROBERFL_F_BS = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_F_BS', contex.DoorLeafSurface);
            var KTU_MM_TUEROBERFL_F_GBS = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_F_GBS', contex.DoorLeafSurface);
            if(KTU_MM_TUEROBERFL_F_BS == KTU_MM_TUEROBERFL_F_GBS){
                KTU_MM_FALZ_O_GBSResult = falzOberflacheBS;
                KTU_MM_FALZ_GBSResult = falzBs;
                KTU_MM_FALZ_O_SO_GBSResult = falzOberflacheSonderBs;
            }else {
                if(falzBs == "KEINE LACKIERUNG")
                {
                    KTU_MM_FALZ_GBSResult = falzBs;
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "KLARLACK")
                {
                    KTU_MM_FALZ_GBSResult = falzBs;
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "LACKIERUNG1")
                {
                    KTU_MM_FALZ_GBSResult = "BEIZE1";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "BEIZE1"){
                    KTU_MM_FALZ_GBSResult = "BEIZE2";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else {
                    KTU_MM_FALZ_GBSResult = "BEIZE2";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }
            }

        } else if(turOberflacheBS == "LACKIERUNG" && turOberflacheGBS == "LACKIERUNG"){
            var KTU_MM_TUEROBERFL_L_BS = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_L_BS', contex.DoorLeafSurface);
            var KTU_MM_TUEROBERFL_L_GBS = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_L_GBS', contex.DoorLeafSurface);
            if(KTU_MM_TUEROBERFL_L_BS == KTU_MM_TUEROBERFL_L_GBS){
                KTU_MM_FALZ_O_GBSResult = falzOberflacheBS;
                KTU_MM_FALZ_GBSResult = falzBs;
                KTU_MM_FALZ_O_SO_GBSResult = falzOberflacheSonderBs;
            }else {
               if(falzBs == "KEINE LACKIERUNG")
                {
                    KTU_MM_FALZ_GBSResult = falzBs;
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "KLARLACK")
                {
                    KTU_MM_FALZ_GBSResult = falzBs;
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else if(falzBs == "LACKIERUNG1")
                {
                    KTU_MM_FALZ_GBSResult = "LACKIERUNG2";
                    KTU_MM_FALZ_O_GBSResult = KTU_MM_TUEROBERFL_L_GBS;
                    KTU_MM_FALZ_O_SO_GBSResult = tuerOberflacheSonderGBs;

                }else if(falzBs == "BEIZE1"){
                    KTU_MM_FALZ_GBSResult = "BEIZE2";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }else {
                    KTU_MM_FALZ_GBSResult = "BEIZE2";
                    KTU_MM_FALZ_O_GBSResult = "NEIN";
                    KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
                }
            }
        }else {
                KTU_MM_FALZ_GBSResult = "BEIZE2";
                KTU_MM_FALZ_O_GBSResult = "NEIN";
                KTU_MM_FALZ_O_SO_GBSResult = "FALZ passend";
        }
    }


    //KTU_MM_FALZ_O_GBS
    const TurOberflacheFalzGBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_FALZ_O_GBS')[0];
    const TurOberflacheFalzGBSValue: ValueDefinition = TurOberflacheFalzGBSCharacteristic.values.filter((v: ValueDefinition) => v.value === KTU_MM_FALZ_O_GBSResult)[0];
    
    //KTU_MM_FALZ_GBS
    const TurOberFalzGBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_FALZ_GBS')[0];
    const TurFalzGBSValue: ValueDefinition = TurOberFalzGBSCharacteristic.values.filter((v: ValueDefinition) => v.value === KTU_MM_FALZ_GBSResult)[0];

    return [TurOberflacheFalzGBSValue,TurFalzGBSValue,KTU_MM_FALZ_O_SO_GBSResult]
}

//KTU_MM_FALZ_O_BS
export const getDoorSurfcaseFalzLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    const custFalzValue = helper.GetDependencyValueCode('CUST_MM_FALZ_O_BS', contex.DoorLeafSurface);
    if (custFalzValue === '1' ) {
        lltNumber = 'LLT130010';
    }
    else if (custFalzValue === '2' ) {
        lltNumber = 'LLT130001';
    }
    else if (custFalzValue === '3' ) {
        lltNumber = 'LLT130002';
    }
    else if (custFalzValue === '4' ) {
        lltNumber = 'LLT130003';
    }
    else if (custFalzValue === '5' ) {
        lltNumber = 'LLT130004';
    }
    else if (custFalzValue === '6' ) {
        lltNumber = 'LLT130005';
    }
    else if (custFalzValue === '7' ) {
        lltNumber = 'LLT130006';
    }
    else if (custFalzValue === '8' ) {
        lltNumber = 'LLT130007';
    }
    else if (custFalzValue === '9' ) {
        lltNumber = 'LLT130008';
    }
    else if (custFalzValue === '10' ) {
        lltNumber = 'LLT130020';
    }
    else if (custFalzValue === '11' ) {
        lltNumber = 'LLT130009';
    }
    else if (custFalzValue === '12' ) {
        lltNumber = 'LLT130011';
    }
    else if (custFalzValue === '13' ) {
        lltNumber = 'NUG';
    }
    else if (custFalzValue === '14' ) {
        lltNumber = 'BLF';
    }
    else if (custFalzValue === '15' ) {
        lltNumber = 'STBNFL';
    }


    const doorLeafFalzCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_FALZ_O_BS')[0];
    const doorLeafFalzCharacteristicValue: ValueDefinition = doorLeafFalzCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return doorLeafFalzCharacteristicValue;
};

//KTU_MM_ZARGE_OBERFL_BS
export const getDoorSurfcaseZargeBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    const custZargeBSValue = helper.GetDependencyValueCode('CUST_MM_ZARGE_OBERFL_BS_N', contex.DoorLeafSurface);
    if (custZargeBSValue === '1' ) {
        lltNumber = 'LLT130010';
    }
    else if (custZargeBSValue === '2' ) {
        lltNumber = 'LLT130001';
    }
    else if (custZargeBSValue === '3' ) {
        lltNumber = 'LLT130002';
    }
    else if (custZargeBSValue === '4' ) {
        lltNumber = 'LLT130003';
    }
    else if (custZargeBSValue === '5' ) {
        lltNumber = 'LLT130004';
    }
    else if (custZargeBSValue === '6' ) {
        lltNumber = 'LLT130005';
    }
    else if (custZargeBSValue === '7' ) {
        lltNumber = 'LLT130006';
    }
    else if (custZargeBSValue === '8' ) {
        lltNumber = 'LLT130007';
    }
    else if (custZargeBSValue === '9' ) {
        lltNumber = 'LLT130008';
    }
    else if (custZargeBSValue === '10' ) {
        lltNumber = 'LLT130009';
    }
    else if (custZargeBSValue === '11' ) {
        lltNumber = 'LLT130020';
    }
    else if (custZargeBSValue === '12' ) {
        lltNumber = 'LLT130011';
    }

    const doorLeafZargeBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_ZARGE_OBERFL_BS')[0];
    const doorLeafZargeBSCharacteristicValue: ValueDefinition = doorLeafZargeBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return doorLeafZargeBSCharacteristicValue;
};

//KTU_MM_ZARGE_OBERFL_GBS
export const getDoorSurfcaseZargeGBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    const custZargeGBSValue = helper.GetDependencyValueCode('CUST_MM_ZARGE_OBERFL_GBS_N', contex.DoorLeafSurface);
    if (custZargeGBSValue === '1' ) {
        lltNumber = 'LLT130010';
    }
    else if (custZargeGBSValue === '2' ) {
        lltNumber = 'LLT130001';
    }
    else if (custZargeGBSValue === '3' ) {
        lltNumber = 'LLT130002';
    }
    else if (custZargeGBSValue === '4' ) {
        lltNumber = 'LLT130003';
    }
    else if (custZargeGBSValue === '5' ) {
        lltNumber = 'LLT130004';
    }
    else if (custZargeGBSValue === '6' ) {
        lltNumber = 'LLT130005';
    }
    else if (custZargeGBSValue === '7' ) {
        lltNumber = 'LLT130006';
    }
    else if (custZargeGBSValue === '8' ) {
        lltNumber = 'LLT130007';
    }
    else if (custZargeGBSValue === '9' ) {
        lltNumber = 'LLT130008';
    }
    else if (custZargeGBSValue === '10' ) {
        lltNumber = 'LLT130009';
    }
    else if (custZargeGBSValue === '11' ) {
        lltNumber = 'LLT130020';
    }
    else if (custZargeGBSValue === '12' ) {
        lltNumber = 'LLT130011';
    }

    const doorLeafZargeGBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_ZARGE_OBERFL_GBS')[0];
    const doorLeafZargeGBSCharacteristicValue: ValueDefinition = doorLeafZargeGBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return doorLeafZargeGBSCharacteristicValue;
};